import React, { useEffect, useRef, useState } from 'react';
import { Editor } from '@tinymce/tinymce-react';
import './style.scss';

function TextField({input, label, meta: { touched, error },}) {
  const [show, setShow] = useState(true)
  const editorRef = useRef(null);
  const log = () => {
    if (editorRef.current) {
      console.log(editorRef.current.getContent());
    }
  };
  return (
    <div style={{display: show ? 'block' : 'none'}}>
      {label ? <label >{label}</label> : null}
      <Editor
        tinymceScriptSrc='/tinymce/tinymce.min.js'
         onInit={(evt, editor) => editorRef.current = editor}
         initialValue={input.value || '<p style="text-align: center; color: black; font-size: 18px;"><span style="font-size: 18px;"></span></p>'}
         onBlur={() => {
          if (editorRef.current) {
            input.onChange(editorRef.current.getContent())
            input.onBlur()
          }
         }}
         init={{
           height: 250,
           menubar: false,
           paste_as_text: true,
          //  menu: {
          //   file: { title: 'File', items: 'newdocument restoredraft | preview | print ' },
          //   edit: { title: 'Edit', items: 'undo redo | cut copy paste | selectall | searchreplace' },
          //   view: { title: 'View', items: 'code | visualaid visualchars visualblocks | spellchecker | preview fullscreen' },
          //   insert: { title: 'Insert', items: 'template codesample inserttable | charmap emoticons hr | pagebreak nonbreaking anchor toc | insertdatetime' },
          //   format: { title: 'Format', items: 'bold italic underline strikethrough superscript subscript codeformat | formats blockformats fontformats fontsizes align lineheight | forecolor backcolor | removeformat' },
          //   tools: { title: 'Tools', items: 'spellchecker spellcheckerlanguage | code wordcount' },
          //   table: { title: 'Table', items: 'inserttable | cell row column | tableprops deletetable' },
          //   help: { title: 'Help', items: 'help' }
          //  },
          //  images_upload_url: 'upload',
           plugins: [
             'advlist autolink lists link image charmap print preview anchor',
             'searchreplace visualblocks code fullscreen',
             'insertdatetime media table paste code help wordcount link image code media table',
           ],
           fontsize_formats: "8px 10px 12px 14px 18px 24px 36px",
          //  toolbar3: 'formatselect bold italic underline | bullist numlist outdent indent | code',
           toolbar2: '| alignright alignjustify alignselect aligncenter | bullist numlist outdent indent',
           toolbar1: 'fontsize | bold italic underline strikethrough superscript subscript codeformat | forecolor backcolor | removeformat',
           content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:18px }',
         }}
       />
        {touched && ((error && <span style={{color: 'red'}}>{error}</span>))}
    </div>
  )
}

export default React.memo(TextField)


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Card/components/CardModal/components/components/TextField/TextField.jsx